import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-privacy',
  imports: [],
  templateUrl: './terms-privacy.component.html',
  styleUrl: './terms-privacy.component.css',
})
export class TermsPrivacyComponent {

}
